/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChangeRequestCreateOrUpdateRequest,
  ChangeRequestDetails,
  MiddlewareError,
  SetChangeRequestVisibilityAfterApprovalRequest,
} from '../models/index';
import {
    ChangeRequestCreateOrUpdateRequestFromJSON,
    ChangeRequestCreateOrUpdateRequestToJSON,
    ChangeRequestDetailsFromJSON,
    ChangeRequestDetailsToJSON,
    MiddlewareErrorFromJSON,
    MiddlewareErrorToJSON,
    SetChangeRequestVisibilityAfterApprovalRequestFromJSON,
    SetChangeRequestVisibilityAfterApprovalRequestToJSON,
} from '../models/index';

export interface CreateOrUpdateChangeRequestOfCurrentRetailerRequest {
    changeRequestCreateOrUpdateRequest: ChangeRequestCreateOrUpdateRequest;
}

export interface DeleteStoreProfileChangeRequestOfCurrentRetailerRequest {
    uuid: string;
}

export interface GetStoreProfileChangeRequestDetailsOfCurrentRetailerRequest {
    uuid: string;
}

export interface SetVisibilityOfChangeAfterApprovalRequestRequest {
    uuid: string;
    setChangeRequestVisibilityAfterApprovalRequest: SetChangeRequestVisibilityAfterApprovalRequest;
}

/**
 * 
 */
export class StoreProfileChangeRequestResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for createOrUpdateChangeRequestOfCurrentRetailer without sending the request
     */
    async createOrUpdateChangeRequestOfCurrentRetailerRequestOpts(requestParameters: CreateOrUpdateChangeRequestOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['changeRequestCreateOrUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateOrUpdateRequest',
                'Required parameter "changeRequestCreateOrUpdateRequest" was null or undefined when calling createOrUpdateChangeRequestOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/store-profile/updatechangerequest`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateOrUpdateRequestToJSON(requestParameters['changeRequestCreateOrUpdateRequest']),
        };
    }

    /**
     */
    async createOrUpdateChangeRequestOfCurrentRetailerRaw(requestParameters: CreateOrUpdateChangeRequestOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createOrUpdateChangeRequestOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createOrUpdateChangeRequestOfCurrentRetailer(requestParameters: CreateOrUpdateChangeRequestOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createOrUpdateChangeRequestOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for deleteStoreProfileChangeRequestOfCurrentRetailer without sending the request
     */
    async deleteStoreProfileChangeRequestOfCurrentRetailerRequestOpts(requestParameters: DeleteStoreProfileChangeRequestOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling deleteStoreProfileChangeRequestOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/changerequest/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteStoreProfileChangeRequestOfCurrentRetailerRaw(requestParameters: DeleteStoreProfileChangeRequestOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteStoreProfileChangeRequestOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteStoreProfileChangeRequestOfCurrentRetailer(requestParameters: DeleteStoreProfileChangeRequestOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStoreProfileChangeRequestOfCurrentRetailerRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getStoreProfileChangeRequestDetailsOfCurrentRetailer without sending the request
     */
    async getStoreProfileChangeRequestDetailsOfCurrentRetailerRequestOpts(requestParameters: GetStoreProfileChangeRequestDetailsOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getStoreProfileChangeRequestDetailsOfCurrentRetailer().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/changerequest/{uuid}`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getStoreProfileChangeRequestDetailsOfCurrentRetailerRaw(requestParameters: GetStoreProfileChangeRequestDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequestDetails>> {
        const requestOptions = await this.getStoreProfileChangeRequestDetailsOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestDetailsFromJSON(jsonValue));
    }

    /**
     */
    async getStoreProfileChangeRequestDetailsOfCurrentRetailer(requestParameters: GetStoreProfileChangeRequestDetailsOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequestDetails> {
        const response = await this.getStoreProfileChangeRequestDetailsOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setVisibilityOfChangeAfterApprovalRequest without sending the request
     */
    async setVisibilityOfChangeAfterApprovalRequestRequestOpts(requestParameters: SetVisibilityOfChangeAfterApprovalRequestRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling setVisibilityOfChangeAfterApprovalRequest().'
            );
        }

        if (requestParameters['setChangeRequestVisibilityAfterApprovalRequest'] == null) {
            throw new runtime.RequiredError(
                'setChangeRequestVisibilityAfterApprovalRequest',
                'Required parameter "setChangeRequestVisibilityAfterApprovalRequest" was null or undefined when calling setVisibilityOfChangeAfterApprovalRequest().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/ui/store-profile/changerequest/{uuid}/visibility`;
        urlPath = urlPath.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetChangeRequestVisibilityAfterApprovalRequestToJSON(requestParameters['setChangeRequestVisibilityAfterApprovalRequest']),
        };
    }

    /**
     */
    async setVisibilityOfChangeAfterApprovalRequestRaw(requestParameters: SetVisibilityOfChangeAfterApprovalRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.setVisibilityOfChangeAfterApprovalRequestRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async setVisibilityOfChangeAfterApprovalRequest(requestParameters: SetVisibilityOfChangeAfterApprovalRequestRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.setVisibilityOfChangeAfterApprovalRequestRaw(requestParameters, initOverrides);
    }

}
